import API from "./axios"

// check email availability
export const checkEmail = (data) => API.post("/check-email", data)

// signup
export const signup = (data) => API.post("/signup", data)

// verify OTP
export const verifyOtp = (data) => API.post("/verify-otp", data)

// resend OTP
export const resendOtp = (data) => API.post("/resend-otp", data)

// login
export const login = (data) => API.post("/login", data)

// logout
export const logout = () => API.post("/logout")

// forgot password
export const forgotPassword = (data) => API.post("/forgot-password", data)

// reset password
export const resetPassword = (data) => API.post("/reset-password", data)

// change password
export const changePassword = (data) => API.post("/change-password", data)